import { Link } from "react-router-dom";
import { Wordmark } from "@/components/marketing/Wordmark";

export default function AuthShell({ title, subtitle, children, footer }) {
  return (
    <div className="night min-h-screen flex flex-col">
      <div className="p-6">
        <Link to="/" className="w-fit" data-testid="auth-brand">
          <Wordmark />
        </Link>
      </div>
      <div className="flex-1 grid place-items-center px-5 pb-16">
        <div className="w-full max-w-md fade-up">
          <h1 className="font-display text-3xl text-[#F7F5F0] mb-2">{title}</h1>
          {subtitle && <p className="text-[#A39E98] text-sm mb-8">{subtitle}</p>}
          <div className="card-night rounded-2xl p-7">{children}</div>
          {footer && <div className="text-center text-sm text-[#A39E98] mt-6">{footer}</div>}
        </div>
      </div>
    </div>
  );
}

export const inputCls = "w-full bg-[#121110] border border-[#2E2C2A] rounded-lg px-4 py-3 text-[#F7F5F0] text-[15px] placeholder-[#6b665e] focus:outline-none focus:border-[#C2836B]/70 focus:ring-1 focus:ring-[#C2836B]/40 transition-colors";
export const labelCls = "block text-sm text-[#A39E98] mb-2";
